import { useMemo } from 'react'
import { TabsMenuWrapper, TabItem, CustomHeaderList } from './TabsMenu.styles'
import { TabsMenuProps } from './TabsMenu.types'
import { sortByKey } from '../../../utils'
import useId from '../../hooks/useId'

const TabsMenu = ({
  className = '',
  options = [],
  value = '',
  allOptionLabel,
  sortKey,
  buttonStyle,
  styles,
  changeActions,
  uppercase = true,
  hideOnEmpty = false,
  'data-testid': testid = 'tabs-menu',
  heading,
  ...props
}: TabsMenuProps) => {
  const optionList = useMemo(
    () => (sortKey ? sortByKey(options, sortKey) : options),
    [options, sortKey]
  )
  const { getTestId } = useId(testid)

  const currentValue =
    value || (allOptionLabel && 'all') || optionList?.[0]?.slug

  const onClickHandle = (
    event: React.SyntheticEvent<EventTarget>,
    newValue: string
  ) => {
    event.preventDefault()
    event.stopPropagation()
    if (changeActions) {
      changeActions({ newValue })
    }
  }
  const isHidden = hideOnEmpty && options.length === 0

  return !isHidden ? (
    <>
      {!!heading && <CustomHeaderList {...heading} />}
      <TabsMenuWrapper
        className={`TabsMenu ${className}`}
        value={currentValue}
        buttonStyle={buttonStyle}
        sx={styles}
        data-testid={getTestId()}
        {...props}>
        {allOptionLabel && (
          <TabItem
            key="all"
            value="all"
            label={allOptionLabel}
            buttonStyle={buttonStyle}
            uppercase={uppercase}
            data-testid={getTestId('all')}
            onClick={(e) => onClickHandle(e, 'all')}
          />
        )}
        {optionList?.map(({ name, slug }) => {
          return (
            <TabItem
              key={slug}
              value={slug}
              label={name}
              uppercase={uppercase}
              buttonStyle={buttonStyle}
              data-testid={getTestId(slug)}
              onClick={(e) => onClickHandle(e, slug)}
            />
          )
        })}
      </TabsMenuWrapper>
    </>
  ) : null
}

export default TabsMenu
